import { Alert, AlertColor, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { themeModeAtom, themeModeEnum } from 'src/recoil/atoms/themeModeAtom';

const useStyles = makeStyles((theme: Theme) => ({
  infoCard: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '& a': {
      textDecoration: 'underline',
    },
  },
}));
export default function InfoPanel(props: {
  children: React.ReactElement;
  color?: AlertColor;
}) {
  const classes = useStyles();
  const themeMode = useRecoilValue(themeModeAtom);
  return (
    <Alert
      className={classes.infoCard}
      variant={themeMode === themeModeEnum.DARK_MODE ? 'outlined' : 'standard'}
      severity={props?.color ?? 'info'}
    >
      {props.children}
    </Alert>
  );
}
